const Badge = ({ link, image, name, issuer }) => (
    <div className="badge-holder">
        <div id="badge">
            <a target="_blank" href={link} rel="noopener noreferrer">
            <img width="105" height="105" alt="" src={image} />
            <span id="badge-name">{name}</span>
            </a>
            <div id="badge-issuer" title={issuer}>
            Issuer: {issuer}
            </div>
        </div>
        <div id="provided">
            <a target="_blank" href="/" rel="noopener noreferrer">PROVIDED BY
            <span>Credly</span>
            </a>
        </div>
    </div>
);
export default Badge;